import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface AppState {
  domain: string;
  title: string;
  subTitle: string;
}

const initialState: AppState = {
  domain: '',
  title: '',
  subTitle: '',
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setDomain: (state, action: PayloadAction<string>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.domain = action.payload;
    },
    setTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setSubTitle: (state, action: PayloadAction<string>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.subTitle = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setDomain, setTitle, setSubTitle } = appSlice.actions;

export default appSlice.reducer;
